// extracted by mini-css-extract-plugin
module.exports = {"root":"NoOrderResults_root__2BhQL","content":"NoOrderResults_content__1G4G9","message":"NoOrderResults_message__KiMuK"};